import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import AuthShell, { googleLogin } from "./AuthShell";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", business_name: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created!");
      const intended = localStorage.getItem("wls_intended_plan");
      navigate(intended ? "/pricing" : "/portal");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Create your account"
      subtitle="Start your website project with WebLaunch Studio."
      footer={<>Already have an account? <Link to="/login" className="text-[#C9A227] font-medium">Log in</Link></>}
    >
      <Button data-testid="google-register-btn" type="button" variant="outline" onClick={googleLogin} className="w-full h-12 rounded-full border-white/20">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-5 w-5 mr-2" /> Sign up with Google
      </Button>
      <div className="my-6 flex items-center gap-4 text-xs text-[#7E7663]">
        <div className="h-px flex-1 bg-slate-200" /> OR <div className="h-px flex-1 bg-slate-200" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label>Full name</Label><Input data-testid="register-name" value={form.name} onChange={set("name")} required className="h-11" /></div>
          <div className="space-y-1.5"><Label>Business</Label><Input data-testid="register-business" value={form.business_name} onChange={set("business_name")} className="h-11" /></div>
        </div>
        <div className="space-y-1.5"><Label>Email</Label><Input data-testid="register-email" type="email" value={form.email} onChange={set("email")} required className="h-11" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label>Phone</Label><Input data-testid="register-phone" value={form.phone} onChange={set("phone")} className="h-11" /></div>
          <div className="space-y-1.5"><Label>Password</Label><Input data-testid="register-password" type="password" value={form.password} onChange={set("password")} required minLength={6} className="h-11" /></div>
        </div>
        <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full h-12 rounded-full bg-[#C9A227] hover:bg-[#B0891C] text-black">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
    </AuthShell>
  );
}
